var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 20.7502C6.66602 19.4627 7.10406 18.1603 8.17391 17.444C9.45696 16.585 11.0025 16.0835 12.666 16.0835C14.3295 16.0835 15.8751 16.585 17.1581 17.444C18.228 18.1603 18.666 19.4627 18.666 20.7502",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 12.7502C14.5083 12.7502 16.0007 11.2578 16.0007 9.41683C16.0007 7.57588 14.5083 6.0835 12.6673 6.0835C10.8264 6.0835 9.33398 7.57588 9.33398 9.41683C9.33398 11.2578 10.8264 12.7502 12.6673 12.7502Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.4165C21.4801 9.4165 22.8553 9.91904 23.9965 10.7797C24.9639 11.5093 25.3333 12.7433 25.3333 13.9549V14.0832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 6.08333C21.4734 6.08333 22.6673 4.88943 22.6673 3.41667C22.6673 1.94391 21.4734 0.75 20.0007 0.75C18.5279 0.75 17.334 1.94391 17.334 3.41667C17.334 4.88943 18.5279 6.08333 20.0007 6.08333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9.4165C3.85316 9.4165 2.47795 9.91904 1.33675 10.7797C0.369413 11.5093 0 12.7433 0 13.9549V14.0832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 6.08333C6.80544 6.08333 7.99935 4.88943 7.99935 3.41667C7.99935 1.94391 6.80544 0.75 5.33268 0.75C3.85992 0.75 2.66602 1.94391 2.66602 3.41667C2.66602 4.88943 3.85992 6.08333 5.33268 6.08333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.e77213cb84d2b55ea697dde9af12077a.svg";
export { ForwardRef as ReactComponent };